module.exports = __webpack_public_path__ + "assets/img/case2.01b86c2f.png";